import type { MenuKey } from "@safers/auth";
import type { KnownEventCategory } from "@safers/api";
import { cctvLivePath, cctvPlaybackPath, controlPath, healthPath } from "@/routes/paths";
import { isCctvEventCategory } from "@/services/types/events.types";

export type TargetKind = "dashboard" | "cctv" | "playback" | "health" | "national";

interface TargetSpec {
  label: string;
  menu?: MenuKey;
  global?: boolean;
  keywords: string[];
  path: (siteId?: number) => string | null;
}

export const TARGETS: Record<TargetKind, TargetSpec> = {
  cctv: {
    label: "CCTV",
    menu: "CCTV",
    keywords: ["cctv", "씨씨티비", "카메라", "영상"],
    path: (siteId) => (siteId == null ? null : cctvLivePath({ siteId })),
  },
  playback: {
    label: "CCTV 재생",
    menu: "CCTV",
    keywords: ["재생", "녹화", "플레이백", "다시보기", "지난영상"],
    path: (siteId) => (siteId == null ? null : cctvPlaybackPath()),
  },
  health: {
    label: "보건관리",
    menu: "HEALTH",
    keywords: ["보건관리", "보건", "점검표", "체크리스트", "레포트", "리포트", "안전", "건강"],
    path: (siteId) => healthPath(siteId),
  },
  national: {
    label: "전국 관제",
    global: true,
    keywords: ["전국관제", "전국", "전체", "메인화면", "메인"],
    path: () => controlPath(),
  },
  dashboard: {
    label: "현장 대시보드",
    keywords: ["대시보드", "관제", "상황"],
    path: (siteId) => (siteId == null ? null : controlPath(siteId)),
  },
};

export const MATCH_ORDER: TargetKind[] = ["playback", "cctv", "health", "national", "dashboard"];

export interface EventWordSpec {
  category: KnownEventCategory;
  label: string;
  words: string[];
}

export const EVENT_WORDS: EventWordSpec[] = [
  { category: "DETECTION", label: "안전모 미착용", words: ["안전모", "헬멧", "미착용"] },
  { category: "DETECTION", label: "화재", words: ["화재"] },
  { category: "DETECTION", label: "침입", words: ["침입", "무단출입"] },
  { category: "DETECTION", label: "영상 감지", words: ["영상감지"] },
  { category: "SAFETY", label: "가스", words: ["가스"] },
  { category: "SAFETY", label: "생체신호", words: ["생체신호", "밴드"] },
  { category: "SAFETY", label: "체감온도", words: ["체감온도", "온열", "폭염"] },
  { category: "SAFETY", label: "안전 센서", words: ["안전센서"] },
];

export function targetForEvent(category: KnownEventCategory): TargetKind {
  return isCctvEventCategory(category) ? "cctv" : "dashboard";
}
